import { useAuthState } from '@creditornot/wolt-auth/react';

const emptyArray: string[] = [];

const usePermissions = () => {
  const { user } = useAuthState();
  return user?.permissions || emptyArray;
};

export default usePermissions;
